import { render, staticRenderFns } from "./NetPayShiftsList.vue?vue&type=template&id=24fc0ad6&scoped=true&"
import script from "./NetPayShiftsList.vue?vue&type=script&lang=js&"
export * from "./NetPayShiftsList.vue?vue&type=script&lang=js&"
import style0 from "./NetPayShiftsList.vue?vue&type=style&index=0&id=24fc0ad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc0ad6",
  null
  
)

export default component.exports